import { Alert } from '@components/display/alerts';
import { AlertTitle } from '@mui/material';
import clsx from 'clsx';
import { ReactElement } from 'react';

interface IErrorToastProps {
    title?: string;
    msg?: ReactElement | string;
    containerClassName?: string;
}

const ErrorToast = ({ msg, title = 'ERROR', containerClassName }: IErrorToastProps) => {
    return (
        <div className="flex gap-2 items-center">
            <div className="min-h-[66px] w-1 bg-red-500" />
            <div>
                <p className="font-museo font-bold text-red-500 tracking-tight text-xs leading-7">{title}</p>
                <div className={clsx('md:min-w-[375px] text-black leading-7 text-sm font-roboto', containerClassName)}>
                    {msg}
                </div>
            </div>
        </div>
    );
};

const ErrorAlertToast = ({ msg, title = 'ERROR' }: IErrorToastProps) => (
    <Alert.Error noStyle>
        <AlertTitle>{title}</AlertTitle>
        {msg}
    </Alert.Error>
);

export { ErrorAlertToast, ErrorToast };
export type { IErrorToastProps };
